var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"table-container-section"},[_c('div',{staticClass:"table-container-section__table-view"},[_c('TableComponent',{attrs:{"await-for-season":false}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }